"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="tr">
      <body className="min-h-screen bg-neutral-950 text-white">
        <main className="flex min-h-screen items-center justify-center px-6 py-12">
          <div className="w-full max-w-md space-y-5 rounded-lg border border-white/10 bg-white/10 p-6 shadow-2xl">
            <div className="space-y-2">
              <p className="text-sm font-medium uppercase tracking-wider text-amber-200">
                Magaza hatasi
              </p>
              <h1 className="text-2xl font-semibold">Beklenmeyen bir hata olustu.</h1>
              <p className="text-sm leading-6 text-neutral-300">
                Hata kaydedildi. Sayfayi yeniden deneyebilir veya daha sonra tekrar
                acabilirsiniz.
              </p>
            </div>
            <button
              type="button"
              onClick={reset}
              className="inline-flex h-10 items-center justify-center rounded-md bg-amber-300 px-4 text-sm font-semibold text-neutral-950 transition hover:bg-amber-200"
            >
              Yeniden dene
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
